module.exports = __webpack_public_path__ + "img/spins_1.8b5bcfec.png";